// @ts-nocheck
import React, { Component } from 'react';
import { inject, observer } from "../../../../stores/mobx-compat";
import qs from 'query-string';
import { withRouter } from '../../../../router-compat';
import configs from '../configs';
import { IntegrationLayout, OAuthSetup, ExternalLinkA } from '../_shared';

class Salesforce extends Component {
  componentDidMount() {
    this.props.store.integrations.Salesforce.getConfigs();
    const { code } = qs.parse(this.props.location.search, { ignoreQueryPrefix: true });
    if (code) {
      this.props.store.integrations.Salesforce.getTokens(code)
        .then(() => this.props.history.replace(this.props.location.pathname));
    }
  }

  render() {
    return (
      <IntegrationLayout config={configs.Salesforce}>
        <OAuthSetup
          partnerKey="Salesforce"
          steps={[
            <>Make a Salesforce account <ExternalLinkA href="https://www.salesforce.com/form/signup/freetrial-elf-v2/">here</ExternalLinkA> if you don&apos;t have one already.</>,
            'Grant Movology the necessary permissions:',
            'After authorizing, future captures will be added as Salesforce leads.',
          ]}
        />
      </IntegrationLayout>
    );
  }
}

export default withRouter(inject('store')(observer(Salesforce)));
